"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Text = _interopRequireDefault(require("../Text"));

var _Image = _interopRequireDefault(require("../Image"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Expander = _interopRequireDefault(require("./Expander.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var MainTagContainer = _styledComponents.default.div.withConfig({
  displayName: "Expander__MainTagContainer",
  componentId: "sc-3q5apl-0"
})(["min-height:", ";position:relative;justify-content:space-between;align-items:center;border:", ";box-sizing:border-box;border-radius:", ";", " background-color:", ";cursor:pointer;display:", ";align-items:", ";"], function (_ref) {
  var isCompact = _ref.isCompact;
  return isCompact ? '24px' : '72px';
}, function (_ref2) {
  var theme = _ref2.theme,
      isCompact = _ref2.isCompact;
  return isCompact ? "0" : "1px solid ".concat(theme.colors.greyLight);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius.normal;
}, function (_ref4) {
  var theme = _ref4.theme;
  return (0, _styledComponents.css)(["padding:", ";"], function (_ref5) {
    var isCompact = _ref5.isCompact;
    return isCompact ? "".concat(theme.space.tiny, " ").concat(theme.space.tiny, " ").concat(theme.space.tiny, " ").concat(theme.space.none) : "".concat(theme.space.small);
  });
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.backgroundColor.default;
}, function (_ref7) {
  var show = _ref7.show;
  return show ? 'flex' : 'none';
}, function (props) {
  return props.editOptionNPS ? 'flex-start' : 'center';
});

var ExpanderChildrenContainer = _styledComponents.default.div.withConfig({
  displayName: "Expander__ExpanderChildrenContainer",
  componentId: "sc-3q5apl-1"
})(["display:flex;align-items:", ";"], function (props) {
  return props.editOptionNPS ? 'flex-start' : 'center';
});

var SelectedTagsDescContainer = _styledComponents.default.div.withConfig({
  displayName: "Expander__SelectedTagsDescContainer",
  componentId: "sc-3q5apl-2"
})(["display:flex;flex-direction:column;align-items:flex-start;margin-left:", ";"], function (_ref8) {
  var isCompact = _ref8.isCompact;
  return isCompact ? _constant.DEFAULT_STYLES.TEXT_CONTAINER.COMPACT : _constant.DEFAULT_STYLES.TEXT_CONTAINER.MARGIN_LEFT;
});

var CloseButton = (0, _styledComponents.default)(function (_ref9) {
  var id = _ref9.id,
      icon = _ref9.icon,
      tabIndex = _ref9.tabIndex,
      accessible = _ref9.accessible,
      className = _ref9.className,
      handleClick = _ref9.handleClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    id: id,
    role: "button",
    tabIndex: tabIndex,
    onClick: handleClick,
    onKeyDown: handleClick
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: icon,
    accessible: accessible,
    fontsize: _constant.DEFAULT_STYLES.ICON.FONTSIZE
  }));
}).withConfig({
  displayName: "Expander__CloseButton",
  componentId: "sc-3q5apl-3"
})(["position:relative;cursor:pointer;height:24px;width:24px;right:0px;"]);

var Expander = function Expander(props) {
  var show = props.show,
      theme = props.theme,
      accessible = props.accessible,
      children = props.children,
      selectedSubtags = props.selectedSubtags,
      imageURL = props.imageURL,
      imageWidth = props.imageWidth,
      imageHeight = props.imageHeight,
      label = props.label,
      id = props.id,
      getData = props.getData,
      labelTextType = props.labelTextType,
      ratingDesc = props.ratingDesc,
      title = props.title,
      beforeIcon = props.beforeIcon,
      afterIcon = props.afterIcon,
      editOptionNPS = props.editOptionNPS,
      customProperties = props.customProperties,
      openByDefault = props.openByDefault,
      isCompact = props.isCompact;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _React$useState = _react.default.useState(openByDefault),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      select = _React$useState2[0],
      setSelect = _React$useState2[1];

  var handleClick = function handleClick() {
    setSelect(!select);

    if (!select) {
      getData(id, editOptionNPS);
    } else {
      getData(null, editOptionNPS);
    }
  };

  (0, _react.useEffect)(function () {
    setSelect(openByDefault);
  }, [openByDefault]);

  var getIcon = function getIcon(iconName) {
    if (iconName) return /*#__PURE__*/_react.default.createElement(CloseButton, {
      id: "expander-".concat(iconName),
      tabIndex: tabIndex,
      accessible: accessible,
      handleClick: handleClick,
      icon: iconName
    });
    return null;
  };

  var returnText = function returnText() {
    if (editOptionNPS) return selectedSubtags ? /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      type: labelTextType
    }, selectedSubtags) : null;
    return label ? /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      type: labelTextType
    }, label) : null;
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MainTagContainer, (0, _extends2.default)({
      id: "expander"
    }, customProperties, {
      tabIndex: tabIndex,
      editOptionNPS: editOptionNPS,
      show: show,
      onClick: handleClick,
      isCompact: isCompact
    }), /*#__PURE__*/_react.default.createElement(ExpanderChildrenContainer, {
      editOptionNPS: editOptionNPS
    }, imageURL && /*#__PURE__*/_react.default.createElement(_Image.default, {
      accessible: accessible,
      centerFocus: false,
      height: imageHeight,
      placeHolderBackground: _constant.DEFAULT_STYLES.IMAGE.PLACEHOLDER_BG,
      radius: _constant.DEFAULT_STYLES.IMAGE.RADIUS,
      src: imageURL,
      width: imageWidth,
      customProperties: {
        style: {
          overflow: 'visible'
        }
      }
    }), /*#__PURE__*/_react.default.createElement(SelectedTagsDescContainer, {
      isCompact: isCompact
    }, title && /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      bold: true
    }, title), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        maxWidth: _constant.DEFAULT_STYLES.LABEL.WIDTH
      }
    }, returnText()), ratingDesc != null && /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      color: _constant.DEFAULT_STYLES.RATING.COLOR,
      bold: true,
      type: _constant.DEFAULT_STYLES.RATING.TYPE
    }, ratingDesc, "/10"))), getIcon(select ? afterIcon : beforeIcon)), select && children && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Expander.propTypes = _Expander.default.PropTypes;
Expander.defaultProps = _Expander.default.DefaultProps;
var _default = Expander;
exports.default = _default;